import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-product-card__tag-container _ml-3"
}
const _hoisted_3 = { class: "gfu-card__wrap" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-card__desc gfu-product-card__desc"
}
const _hoisted_5 = {
  class: "gfu-price gfu-price--old gfu-price--tiny _fw-n _ml-1",
  "data-qa": "price-type:Old"
}
const _hoisted_6 = {
  class: "_mx-1",
  "data-qa": "price-type:ThirtyDaysLowest"
}
const _hoisted_7 = {
  key: 0,
  class: "_mt-a",
  "data-qa": "product-box-action"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_image = _resolveComponent("base-image")
  const _component_context_link = _resolveComponent("context-link")
  const _component_display_currency_price = _resolveComponent("display-currency-price")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-card gfu-product-card",
    "data-qa": `product-card:${$props.productID}`
  }, [
    ($options.badges.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.badges, (badge, index) => {
            return (_openBlock(), _createBlock(_component_base_badge, {
              key: index,
              theme: badge.theme,
              class: "gfu-product-card__tag",
              "data-qa": `product-card-badge:${badge.dataQa}`
            }, {
              default: _withCtx(() => [
                (badge.icon)
                  ? (_openBlock(), _createBlock(_component_base_icon, {
                      key: 0,
                      name: badge.icon
                    }, null, 8 /* PROPS */, ["name"]))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString(badge.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_context_link, _mergeProps($options.contextLinkProps, { class: "gfu-embed gfu-embed--1x1" }), {
        default: _withCtx(() => [
          _createVNode(_component_base_image, {
            class: "gfu-embed__item",
            loading: "lazy",
            src: $props.imageUrl,
            alt: $props.name
          }, null, 8 /* PROPS */, ["src", "alt"])
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */),
      _createVNode(_component_context_link, _mergeProps($options.contextLinkProps, {
        class: {
                              'gfu-product-card__body': $props.showAbstract,
                              'gfu-product-card__distinction': !$props.showAbstract,
                          }
      }), {
        default: _withCtx(() => [
          _createElementVNode("h3", {
            class: _normalizeClass(['gfu-product-card__title gfu-heading', {'gfu-product-card__distinction-title': !$props.showAbstract}]),
            "data-qa": "product-name"
          }, _toDisplayString($props.name), 3 /* TEXT, CLASS */),
          ($props.showAbstract)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(_toDisplayString($props.abstract) + " ", 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-product-card__desc-fade" }, null, -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_display_currency_price, {
            "effective-price": $props.effectivePrice,
            price: $props.price,
            "is-discounted": $props.isDiscounted,
            "data-qa": "product-price"
          }, {
            "effective-price": _withCtx(({ effectivePrice }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["gfu-price gfu-price--text-base", [{'gfu-price--discounted': $props.isDiscounted}]]),
                "data-qa": "price-type:Effective"
              }, _toDisplayString(effectivePrice), 3 /* TEXT, CLASS */)
            ]),
            price: _withCtx(({ price }) => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(price), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["effective-price", "price", "is-discounted"]),
          ($props.isDiscounted)
            ? (_openBlock(), _createBlock(_component_localize, {
                key: 1,
                resource: _ctx.Resources.Product.RewardCardLowestPriceInLast30Days,
                class: "gfu-bt gfu-bt--caption _tc--lighter",
                tag: "div"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_display_currency_price, {
                    "format-key": "0",
                    "effective-price": $props.effectivePrice,
                    price: $props.price,
                    tag: "span"
                  }, {
                    "effective-price": _withCtx(({ effectivePrice }) => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(effectivePrice), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["effective-price", "price"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */, ["class"]),
      ($options.hasAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "action")
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}